import React from 'react'
import { useTranslation } from 'i18n'

// TODO: would be nice to pull values out of `review` and incude them as individual props

const ReminderThankYouScreen = ({
  review,
  email,
  productTitle,
  productImageUrl,
  reminderDate,
}) => {
  const { t } = useTranslation('review')

  return (
    <div className={`reminder-thankyou-screen`}>
      <div className="header">
        <h1
          dangerouslySetInnerHTML={{ __html: review.reminderThankyouHeader }}
        />
        <div
          className="intro"
          dangerouslySetInnerHTML={{ __html: review.reminderThankyouIntro }}
        />
      </div>

      <div className="detail">
        <div className="image">
          <img src={productImageUrl} alt="" />
        </div>
        <div className="copy">
          <p>{t('reminder.setConfirmation')}</p>
          <p>{email}</p>
          <p
            className="copy-product"
            dangerouslySetInnerHTML={{ __html: productTitle }}
          />
          <p>{t('reminder.followUpNotice')}</p>
        </div>
      </div>

      <div className="body">
        <div
          className="copy"
          dangerouslySetInnerHTML={{ __html: review.reminderThankyouBody }}
        />
        {review.reminderThankyouBodyButton && (
          <a
            className="btn"
            role="button"
            target="_blank"
            rel="noreferrer"
            href={review.reminderThankyouBodyButtonUrl}
          >
            {review.reminderThankyouBodyButton}
          </a>
        )}
      </div>
    </div>
  )
}

export default ReminderThankYouScreen
